const version = process.env.VERSION || '7.3.11';
const mode = process.env.NWF || '';
const finalVersion = version + mode;
module.exports = finalVersion;
